import React from 'react'
import styled from 'styled-components'
import {
  Button,
  Row,
} from 'reactstrap'
import get from 'lodash/get'
import { FONTS } from '../../../../constants'

export const CategoryButton = (props) => {
  const timesheetByProjects = get(props, 'timesheetByProjects.meta')
  const numberOfPeople = get(timesheetByProjects, 'numberOfPeople', 0)
  const timesheetApproved = get(timesheetByProjects, 'timesheetApproved', 0)
  const timesheetPending = get(timesheetByProjects, 'timesheetPending', 0)
  const timesheetRejected = get(timesheetByProjects, 'timesheetRejected', 0)
  const timesheetUnsubmited = get(timesheetByProjects, 'timesheetUnsubmited', 0)
  return (
    <Wrapper>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(1) }
        active={ get(props, 'filterButton') === 1 }
      >
        <TextRow>
          <Circle />
          <TextButton color=''>Show All</TextButton>
        </TextRow>
        <TextRow>
          <TextNumber >{`${numberOfPeople} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(2) }
        active={ get(props, 'filterButton') === 2 }
      >
        <TextRow>
          <Circle
            color='#BBBBBB'
            active={ get(props, 'filterButton') === 2 }
          />
          <TextButton
            color='#BBBBBB'
            active={ get(props, 'filterButton') === 2 }
          >
          Unsubmitted
          </TextButton>
        </TextRow>
        <TextRow>
          <TextNumber>{ `${timesheetUnsubmited} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(3) }
        active={ get(props, 'filterButton') === 3 }
      >
        <TextRow>
          <Circle
            color='#F0AD4E'
            active={ get(props, 'filterButton') === 3 }
          />
          <TextButton
            color='#F0AD4E'
            active={ get(props, 'filterButton') === 3 }
          >
          Pending
          </TextButton>
        </TextRow>
        <TextRow>
          <TextNumber>{ `${timesheetPending} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(4) }
        active={ get(props, 'filterButton') === 4 }
      >
        <TextRow>
          <Circle
            color='#5CB85C'
            active={ get(props, 'filterButton') === 4 }
          />
          <TextButton
            color='#5CB85C'
            active={ get(props, 'filterButton') === 4 }
          >Approve</TextButton>
        </TextRow>
        <TextRow>
          <TextNumber>{ `${timesheetApproved} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(5) }
        active={ get(props, 'filterButton') === 5 }
      >
        <TextRow>
          <Circle
            color='#D44B49'
            active={ get(props, 'filterButton') === 5 }
          />
          <TextButton
            color='#D44B49'
            active={ get(props, 'filterButton') === 5 }
          >
          Rejected
          </TextButton>
        </TextRow>
        <TextRow>
          <TextNumber>{ `${timesheetRejected} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
    </Wrapper>
  )
}

const Categorybutton = styled(Button)`
  background-color: ${(props) => {
    if (props.active) {
      return '#D44B49 !important'
    } return '#ffffff'
  }};
  color: #000;
  height: 50px;
  width: 10%;
  margin: 5px;
  border: ${(props) => {
    if (props.active) {
      return '1px solid #D44B49 !important'
    } return '#cccccc'
  }};
  cursor: pointer;
`
const TextRow = styled(Row)`
  justify-content: center;
`
const TextButton = styled.label`
  font-family: ${FONTS.GOTHAM} !important;
  text-align: center;
  margin-bottom: 0;
  color: ${(props) => {
    if (props.active) {
      return '#ffffff !important'
    } return props.color
  }};
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const TextNumber = styled.label`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  text-align: center;
  margin-bottom: 0;
  width: 100%;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Wrapper = styled.div`
  background-color: #EEEEEE ;
  height: 60px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #EEEEEE;
  padding-left: 10px;
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => {
    if (props.active) {
      return '#ffffff !important'
    } return props.color
  }};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-by-project/category-button.js